module.exports = __webpack_public_path__ + "img/pauli-z-root-1.fdbe7e85.svg";